import { ContentPasteSearch, HelpOutline } from '@mui/icons-material'
import * as React from 'react'
import { formatDate, isWindow } from '@/@core/utils/utils'
import {
  Backdrop,
  Box,
  Card,
  CardContent,
  CircularProgress,
  circularProgressClasses,
  CircularProgressProps,
  Drawer,
  Grid,
  IconButton,
  Pagination,
  Stack,
  SvgIcon,
  Tooltip,
  Typography
} from '@mui/material'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import CloseIcon from '@mui/icons-material/Close'
import { useTranslation } from 'react-i18next'

import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf'
import router from 'next/router'
import { ClipboardTextSearchOutline } from 'mdi-material-ui'

const ReportSearchIcon = React.forwardRef((props, ref) => {
  const { t } = useTranslation()

  return (
    <Box>
      <Tooltip title={t('Report search')} placement="top-start">
        <IconButton
          onClick={() => {
            // setOpen(true)
            window.open(`/reports/ReportSearch/`)
          }}
        >
          <ClipboardTextSearchOutline />
        </IconButton>
      </Tooltip>
    </Box>
  )
})

export default ReportSearchIcon
